import { allEnumValues, UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const userSchema = {
    displayName: 'user',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        username: {
            type: 'email',
            displayName: 'Email',
            required: true,
            usesModelValidation: true,
            isPermanent: true,
        },
        firstName: {
            type: 'shortString',
            displayName: 'First Name',
        },
        lastName: {
            type: 'shortString',
            displayName: 'Last Name',
        },
        accessCode: {
            type: 'keyString',
            validationRegex: '^[0-9]{4}$',
            displayName: 'Access Code',
            usesModelValidation: true,
        },
        password: {
            type: 'password',
            required: true,
            usesModelValidation: true,
            isPermanent: true,
            tooltip: {
                text: 'Password must be 14-32 characters long and contain at least one uppercase letter, one lowercase letter, and one number.',
            },
        },
        slackId: {
            type: 'keyString',
            displayName: 'Slack ID',
            biteOnly: true,
            tooltip: {
                text: 'Found by clicking "Copy member ID" when viewing a Slack user\'s full profile. ex: U026G0BT31C',
            },
        },
        disabled: {
            displayName: 'Suspended',
            type: 'bool',
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
        },
        locationGroupId: {
            type: 'mongoId',
            displayName: 'Location Access',
            ui: 'dropdown',
        },
        userRoleId: {
            type: 'mongoId',
            required: true,
            displayName: 'Role',
            ui: 'dropdown',
        },
        biteMembership: {
            type: 'object',
            displayName: 'Bite Membership',
            isHidden: true,
            isReadOnly: true,
            fields: {
                disabled: {
                    displayName: 'Suspended',
                    type: 'bool',
                },
                accessCode: {
                    type: 'keyString',
                },
                userRoleId: {
                    type: 'mongoId',
                    required: true,
                },
                rights: {
                    type: 'array',
                    elementType: 'int',
                    elementValues: allEnumValues(UserRight),
                    required: true,
                    minCount: 1,
                },
            },
        },
        orgMemberships: {
            type: 'array',
            elementType: 'object',
            displayName: 'Memberships',
            isHidden: true,
            isReadOnly: true,
            fields: {
                disabled: {
                    displayName: 'Suspended',
                    type: 'bool',
                },
                orgId: {
                    type: 'mongoId',
                    required: true,
                },
                orgName: {
                    type: 'shortString',
                    required: true,
                },
                orgNormalizedName: {
                    type: 'shortString',
                    required: true,
                },
                locationGroupId: {
                    type: 'mongoId',
                    required: true,
                },
                locationIds: {
                    type: 'array',
                    elementType: 'mongoId',
                    required: true,
                    minCount: 1,
                },
                accessCode: {
                    type: 'keyString',
                },
                userRoleId: {
                    type: 'mongoId',
                    required: true,
                },
                rights: {
                    type: 'array',
                    elementType: 'int',
                    elementValues: allEnumValues(UserRight),
                    required: true,
                    minCount: 1,
                },
            },
        },
    },
    searchFields: ['username', 'firstName', 'lastName', 'accessCode'],
};
//# sourceMappingURL=user_schema.js.map